import { Serializable } from '../../core/models/serializable';
export class EducationLevelModel implements Serializable<EducationLevelModel> {
  fromObject(obj: any): EducationLevelModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public educationLevelId: number;
  public name: string;
}
